/* Moksae Journal — article interactions: reading progress, back-to-top, copy link */
(function () {
  function init() {
    var article = document.querySelector('.article-template');
    if (!article) return;

    var content = article.querySelector('.article-template__content');
    var progressBar = document.querySelector('.mja-progress__bar');
    var topBtn = document.querySelector('.mja-top');

    // Reading progress based on the content block scroll position
    function onScroll() {
      if (progressBar && content) {
        var rect = content.getBoundingClientRect();
        var total = rect.height - window.innerHeight;
        var scrolled = Math.min(Math.max(-rect.top, 0), Math.max(total, 0));
        var pct = total > 0 ? (scrolled / total) * 100 : 0;
        progressBar.style.width = pct + '%';
      }
      if (topBtn) {
        if (window.scrollY > 600) {
          topBtn.classList.add('is-visible');
        } else {
          topBtn.classList.remove('is-visible');
        }
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();

    if (topBtn) {
      topBtn.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    // Copy-link share buttons
    var copyButtons = article.querySelectorAll('[data-mja-copy]');
    copyButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-mja-copy') || window.location.href;
        var done = function () {
          var original = btn.getAttribute('aria-label');
          btn.setAttribute('aria-label', 'Link copied');
          btn.classList.add('is-copied');
          setTimeout(function () {
            btn.setAttribute('aria-label', original || 'Copy link');
            btn.classList.remove('is-copied');
          }, 1800);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done).catch(done);
        } else {
          var tmp = document.createElement('input');
          tmp.value = url;
          document.body.appendChild(tmp);
          tmp.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(tmp);
          done();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
